var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_70200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6669 3.14687H4.3335C2.47878 3.14687 0.970605 4.65505 0.970605 6.50977V26.82C0.970605 28.6747 2.47878 30.1829 4.3335 30.1829H17.4524L16.6763 34.7494H13.7213C13.1942 34.7494 12.7674 35.1761 12.7674 35.7026V37.8983C12.7674 38.4249 13.1942 38.8516 13.7213 38.8516H28.2791C28.8064 38.8516 29.2323 38.4248 29.2323 37.8983V35.7026C29.2323 35.1762 28.8064 34.7494 28.2791 34.7494H25.3234L24.546 30.1829H37.6669C39.5216 30.1829 41.0298 28.6747 41.0298 26.82V6.50977C41.0298 4.65505 39.5216 3.14687 37.6669 3.14687ZM4.3335 5.05332H37.6669C38.4699 5.05332 39.1233 5.70731 39.1233 6.50977V24.2692H2.87705V6.50977C2.87705 5.70731 3.53044 5.05332 4.3335 5.05332ZM27.3259 36.9451H14.6745V36.6559H27.3259V36.9451ZM23.3908 34.7494H18.6103L19.3871 30.1829H22.6133L23.3908 34.7494ZM37.6669 28.2765H4.3335C3.5304 28.2765 2.87705 27.6231 2.87705 26.82V26.1757H39.1233V26.82C39.1233 27.6231 38.47 28.2765 37.6669 28.2765Z",
    fill: "#4088F4",
    stroke: "#4088F4",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_70200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounComputer);
export default __webpack_public_path__ + "static/media/noun-computer.505cf002141ba294920591eba2721cc6.svg";
export { ForwardRef as ReactComponent };